import { __assign, __read } from "tslib";
import { KEEN_KEY, KEEN_VALUE, KEEN_ELEMENTS } from '../../../constants';
export var choroplethChartTransformation = function (result, _parserSettings, groupBySettings) {
    var _a = __read(groupBySettings, 2), geoKey = _a[0], propertyKey = _a[1];
    var parsedResults = {};
    result.forEach(function (record) {
        var _a, _b, _c, _d;
        var geoMatcher = record[geoKey];
        if (parsedResults[geoMatcher]) {
            parsedResults[geoMatcher] = __assign(__assign({}, parsedResults[geoMatcher]), (_a = {}, _a[KEEN_VALUE] = parsedResults[geoMatcher][KEEN_VALUE] + record.result, _a[KEEN_ELEMENTS] = __assign(__assign({}, parsedResults[geoMatcher][KEEN_ELEMENTS]), (_b = {}, _b[record[propertyKey]] = record.result, _b)), _a));
        }
        else {
            parsedResults[geoMatcher] = (_c = {},
                _c[KEEN_KEY] = geoMatcher,
                _c[KEEN_VALUE] = record.result,
                _c[KEEN_ELEMENTS] = (_d = {},
                    _d[record[propertyKey]] = record.result,
                    _d),
                _c);
        }
    });
    return {
        data: Object.keys(parsedResults).map(function (keyName) { return parsedResults[keyName]; }),
        keys: [KEEN_VALUE],
    };
};
